import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import pages from './pages.ts';

export default function Bar() {
  const navigate = useNavigate();
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h6" component="div">
            CemEzgi
          </Typography>
          <Box display="flex" flex="1" ml={2} overflow="scroll">
            {
              pages.map(page => <Button key={page.url} color='inherit' onClick={() => navigate(page.url)}>{page.title}</Button>)
            }
            <Box flex="1"/>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </Box>
  );
}